export default "__VITE_ASSET__DLSKCM0O__"